module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/building-71f3f32a4088da9c389c455c6f4d0880.svg";